import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { getTaskMail, updateTask } from '../../Redux/GetSlice';
import 'react-datepicker/dist/react-datepicker.css';
import ReminderDateTimePicker from './ReminderDateTimePicker';
import { useTaskData } from '../../hooks/useTaskData';

export default function TaskDeadline({
    currentTaskId,
    setSelectedMyDayPlanDate,
    selectedMyDayPlanDate,
    handleUpdateTask,
    isOpen,
    onClose,
    taskItem,
    getTaskMail,
    handleDateSelect,
    isDeadlineChecked,
    setIsDeadlineChecked,
    clickedBellIcon,
    fixedPosition,
}) {
    const [customDate, setCustomDate] = useState(null);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const dropdownRef = useRef(null);
    const dispatch = useDispatch();
    const {

        selectedMyDayPlanDate: reduxSelectedMyDayPlanDate,
        selectedReminderDate,
        selectedStatusNextStepDate,
        note,
        notesText,
        myDayDate,
        deadlineDate,
        isMyDayChecked,
        isDeadlineChecked: reduxIsDeadlineChecked,
        updateSelectedMyDayPlanDate: updateSelectedMyDayPlanDateRedux,
        updateSelectedReminderDate,
        updateSelectedStatusNextStepDate,
        updateNote,
        updateNotesText,
        updateMyDayDate,
        updateDeadlineDate,
        updateIsMyDayChecked,
        updateIsDeadlineChecked: updateIsDeadlineCheckedRedux,
        handleDateSelect: handleDateSelectFromHook,
        handleUpdateTask: handleUpdateTaskFromHook,
        resetAllTaskData,
    } = useTaskData();


    const formatToLocalISO = (date) => {
        const time = date.getTime()
        return formatEpochToISO(time);
    };
    const formatEpochToISO = (epochMillis) => {
        const date = new Date(epochMillis < 1e12 ? epochMillis * 1000 : epochMillis);
        return date.toISOString();
    };

    const formatDateForDisplay = (date) => {
        if (!date) return '';
        return new Date(date).toLocaleString('en-US', {
            weekday: 'short',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
        });
    };


    const getFormattedDate = (dateOption) => {
        if (dateOption && typeof dateOption === 'object' && 'daysToAdd' in dateOption) {
            const date = new Date();
            date.setDate(date.getDate() + dateOption.daysToAdd);
            date.setHours(dateOption.time.hours, dateOption.time.minutes, 0, 0);
            return date;
        }

        return dateOption;
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                if (onClose) {
                    onClose();
                }
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [onClose]);

    useEffect(() => {
        if (deadlineDate) {
            const date = new Date(deadlineDate);
            setCustomDate(date);
        }
    }, [deadlineDate]);

    const handleReminderSelection = (dateOption) => {
        const date = getFormattedDate(dateOption);
        const formattedDate = formatToLocalISO(date);
        updateDeadlineDate(formattedDate);
        handleUpdateTask(formattedDate, 'deadline', taskItem);

        if (onClose) {
            onClose();
        }
    };

    const handleDateChange = (date) => {
        setCustomDate(date);
        setShowDatePicker(false);
        handleReminderSelection(date);
    };

    const handleDateOnlyChange = (date) => {
        const next = customDate ? new Date(customDate) : new Date();
        next.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
        if (!customDate) {
            next.setHours(8, 0, 0, 0);
        }
        setCustomDate(next);
    };

    const toggleDatePicker = () => {
        if (!showDatePicker) {
            setCustomDate(customDate || new Date());
        }
        setShowDatePicker(!showDatePicker);
    };

    const handleClearDeadline = () => {
        updateDeadlineDate(null);
        if (setSelectedMyDayPlanDate) {
            setSelectedMyDayPlanDate(null);
        }
        if (handleUpdateTask) {
            handleUpdateTask(null, 'deadline');
        } else {
            handleUpdateTaskFromHook(null, 'deadline', taskItem);
        }
    };

    const currentIsDeadlineChecked = reduxIsDeadlineChecked !== undefined ? reduxIsDeadlineChecked : isDeadlineChecked;
    const currentSetIsDeadlineChecked = updateIsDeadlineCheckedRedux || setIsDeadlineChecked;

    const today = { daysToAdd: 0, time: { hours: 12, minutes: 0 } };
    const tomorrow = { daysToAdd: 1, time: { hours: 8, minutes: 0 } };
    const inTwoDays = { daysToAdd: 2, time: { hours: 8, minutes: 0 } };
    const nextWeek = { daysToAdd: 7, time: { hours: 8, minutes: 0 } };

    const presetOptions = [
        { key: 'today', label: 'Later today', icon: '☀️', option: today },
        { key: 'tomorrow', label: 'Tomorrow', icon: '🌙', option: tomorrow },
        { key: 'twoDays', label: 'In two days', icon: '🕒', option: inTwoDays },
        { key: 'nextWeek', label: 'Next week', icon: '📅', option: nextWeek },
    ];

    const dropdownEl = (
            <div
                className={`reminder-dropdown ${clickedBellIcon ? 'reminder-dropdown--bell' : fixedPosition ? 'reminder-dropdown--fixed' : 'reminder-dropdown--anchored'}`}
                style={
                    fixedPosition
                        ? { top: fixedPosition.top, right: fixedPosition.right, width: fixedPosition.width || Math.min(300, window.innerWidth - 16), maxHeight: window.innerHeight - fixedPosition.top - 8 }
                        : clickedBellIcon
                            ? { top: '50px', right: '2vw', minWidth: 320 }
                            : { minWidth: 320 }
                }
            >
                <div className={`reminder-dropdown__card ${showDatePicker ? 'reminder-dropdown__card--expanded' : ''}`}>
                    <div className="reminder-dropdown__header">
                        <span className="reminder-dropdown__title">Deadline</span>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <button type="button" onClick={handleClearDeadline} className="reminder-dropdown__clear">Clear</button>
                            <button
                                type="button"
                                onClick={() => { if (onClose) onClose(); }}
                                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#888', fontSize: '16px', lineHeight: 1, padding: '2px 4px' }}
                                title="Close"
                            >✕</button>
                        </div>
                    </div>

                    <ul className="reminder-dropdown__options">
                        {presetOptions.map(({ key, label, icon, option }) => (
                            <li key={key}>
                                <button
                                    type="button"
                                    className="reminder-dropdown__option"
                                    onClick={() => handleReminderSelection(option)}
                                >
                                    <span className="reminder-dropdown__option-left">
                                        <span className="reminder-dropdown__option-icon" aria-hidden="true">
                                            {icon}
                                        </span>
                                        <span className="reminder-dropdown__option-label">{label}</span>
                                    </span>
                                    <span className="reminder-dropdown__option-time">
                                        {formatDateForDisplay(getFormattedDate(option))}
                                    </span>
                                </button>
                            </li>
                        ))}
                        <li className={showDatePicker ? 'reminder-dropdown__pick-row--open' : ''}>
                            <button
                                type="button"
                                className={`reminder-dropdown__option ${showDatePicker ? 'reminder-dropdown__option--active' : ''}`}
                                onClick={toggleDatePicker}
                                aria-expanded={showDatePicker}
                            >
                                <span className="reminder-dropdown__option-left">
                                    <span className="reminder-dropdown__option-icon" aria-hidden="true">
                                        📆
                                    </span>
                                    <span className="reminder-dropdown__option-label">Pick a date</span>
                                </span>
                            </button>
                        </li>
                    </ul>

                    {showDatePicker && (
                        <ReminderDateTimePicker
                            customDate={customDate}
                            setCustomDate={setCustomDate}
                            onDateOnlyChange={handleDateOnlyChange}
                            onSave={() => handleDateChange(customDate)}
                            onToday={() => setCustomDate(new Date())}
                            onClear={() => setCustomDate(null)}
                        />
                    )}

                    <div className="reminder-dropdown__footer">
                        <label className="reminder-dropdown__checkbox-label">
                            <input
                                type="checkbox"
                                className="reminder-dropdown__checkbox"
                                checked={currentIsDeadlineChecked}
                                onChange={(e) => currentSetIsDeadlineChecked(e.target.checked)}
                            />
                            Also update the deadline date
                        </label>
                    </div>
                </div>
            </div>
    );

    if (!isOpen) {
        if (fixedPosition) return null;
        return <div className="relative w-full text-left" ref={dropdownRef} />;
    }

    if (fixedPosition) {
        return dropdownEl;
    }

    return (
        <div className="relative w-full text-left" ref={dropdownRef}>
            {dropdownEl}
        </div>
    );
}
